<!--
  Reload banner shown regardless of auth state: when the bundle is older than the
  backend's declared minimum (version-mismatch) or a lazy chunk failed to load after
  a deploy (chunk-load, TF-1984). On the public path the sessionStorage-guarded
  auto-reload may have already fired and been suppressed, so this is the user-visible
  fallback that always offers a manual reload.
-->
@if (versionService.reloadRequired()) {
  <tf-frontend-version-banner
    [currentVersion]="versionService.currentVersion"
    [minimumVersion]="versionService.minimumRequired()"
    [mode]="versionService.bannerMode()"
    (reloadRequested)="onVersionBannerReload()"
  />
}
<router-outlet></router-outlet>
